<template>
  <div>
    <CardReaderInsert @readed="cardReaderReaded"/>
    <CustomerParentBar />
    <headline :content="`${this.$t('customer.companion_customer_project', { projectName: project.name })}`">
      <div>
        <div class="justify-end d-flex">
          <v-btn class="mb-2 info" @click="isAddCompanionDialog = true">
            <v-icon left>mdi-plus-box-multiple-outline</v-icon>{{ $t('customer.add_companion_seller') }}
          </v-btn>
        </div>
        <div class="d-flex align-center">
          <v-text-field
            solo
            dense
            background-color="grey lighten-4"
            flat
            type="text"
            :placeholder="$t('search')"
            :label="$t('search')"
            prepend-inner-icon="mdi-magnify"
            v-model="searchText"
            clearable
            color
            hide-details
            class="mx-1"
            @click:clear="clearSearch"
          ></v-text-field>
          <v-btn color="primary" class="mx-1" @click="searchCustomer()" :disabled="isLoading">
            <v-icon left>mdi-magnify</v-icon>{{ $t('search') }}
          </v-btn>
        </div>
      </div>
    </headline>
    <layout :isSuccess="true">
      <template v-slot:containerZone>
        <div style="font-size: 1rem">
          <CompanionCustomers
            :projectId="projectId"
            :marketId="marketId"
            :isKeyword="isKeyword"
            :isMainLoading="isLoading"
          />
        </div>
      </template>
    </layout>
    <v-snackbar v-model="isError" color="error" top>
      <v-icon left size="18">mdi-information</v-icon>{{ $t('error') }}
    </v-snackbar>
    <FormCompanion
      v-model="isAddCompanionDialog"
      :event="'create'"
      :projectId="projectId"
      @onCreated="searchCustomer"
      :editFirst="true"
    />
  </div>
</template>

<script>
import CustomerMenu from "../../components/CustomerMenu";
import CompanionCustomers from "../../components/CompanionCustomers.vue";
import Headline from "../../components/Headline";
import ParentBar from "../../components/ParentBar";
import CustomerParentBar from "../../components/CustomerParentBar.component.vue";
import Layout from "../../components/Layout";
import FormCompanion from "../../components/FormCompanion.vue";
import CardReaderInsert from "../../components/CardReaderInsert.vue";
export default {
  components: {
    CustomerMenu,
    CompanionCustomers,
    Headline,
    ParentBar,
    CustomerParentBar,
    Layout,
    FormCompanion,
    CardReaderInsert
  },
  computed: {
    admin() {
      return this.$store.getters["admin/getByMarketId"](this.marketId);
    },
    employee() {
      return this.$store.getters["employee/getByMarketId"](this.marketId);
    }
  },
  watch: {
    admin() {
      if (this.admin) this.initData();
    },
    employee() {
      if (this.employee) this.initData();
    }
  },
  data() {
    return {
      marketId: this.$route.params.marketId,
      projectId: this.$route.params.projectId,
      isSuccess: false,
      isError: false,
      isLoading: false,
      project: null,
      isAddCompanionDialog: false,
      searchText: "",
      isKeyword: false
    };
  },
  created() {
    this.initData();
  },
  props: {},
  methods: {
    initData() {
      this.isLoading = true;
      if (this.admin) {
        this.project = this.admin.project;
      } else if (this.employee) {
        this.project = this.employee.project;
      }
      this.isLoading = false;
    },
    async searchCustomer() {
      this.isLoading = true;
      try {
        if (this.searchText) {
          this.isKeyword = true;
          await this.$store.dispatch("companion/getCompanionByKeyword", {
            keyword: this.searchText
          });
        } else {
          this.isKeyword = false;
          await this.$store.dispatch("companion/getCompanionsByProject", {
            projectId: this.projectId,
            limit: 20,
            page: 0
          });
        }
        this.isLoading = false;
      } catch (error) {
        console.log(error);
        this.isLoading = false;
        this.isError = true;
      }
    },
    async clearSearch() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("companion/getCompanionsByProject", {
          projectId: this.projectId,
          limit: 20,
          page: 0
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.isError = true;
      }
    },
    cardReaderReaded(cardReaderData){
      this.firstAction = 'personal'
      // this.isAddCustomerDialog = true
    }
  }
};
</script>

<style lang="scss" scoped></style>
